import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-menu-list-loader',
  templateUrl: './menu-list-loader.component.html',
  styleUrls: ['./menu-list-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class MenuListLoaderComponent {}
